import {reqCategory,reqSlider,reqRecommend,index} from '@/api';
// 用来存储数据
const state = {
    categorylist:[],
    sliderlist:[],
    recommendlist:[],
    baseinfo:{},

}
// 响应组件中的事件
const actions = {
    async getCategoryList({commit}){
        let result = await reqCategory();
        if(result.code == 200){
            commit('categorylist',result.data);
        }
    },
    async getSlider({commit}){
        let result = await reqSlider();
        if(result.code == 200){
            commit('sliderlist',result.data);
        }
    },
    async getRecommend({commit},params){
        let result = await reqRecommend(params);
        if(result.code == 200){
            commit('recommendlist',result.data);
        }
        
    },
    async getbaseinfo({commit},params){
        let result = await index(params);
        if(result.code == 200){
            commit('index',result.data);
        }
        
    },
    
}
// 操作数据
const mutations = {
    categorylist(state,categorylist){
        state.categorylist = categorylist;
    },
    sliderlist(state,sliderlist){
        state.sliderlist = sliderlist;
    },
    recommendlist(state,recommendlist){
        state.recommendlist = recommendlist;
    },
    baseinfo(state,baseinfo){
        state.baseinfo = baseinfo;
    },
}
// 用来将state数据进行加工
const getters = {

}

export default {
    state,
    actions,
    mutations,
    getters
}